"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.CertificationTooltipComponent = exports.certificationTooltipTestId = void 0;
var React = require("react");
var CertificationIcon_1 = require("./CertificationIcon");
var Certifier_1 = require("./Certifier");
var widgets_1 = require("@tableau/widgets");
var ExtractRefresh_1 = require("./ExtractRefresh");
var Id_1 = require("../common/Id");
var Style_1 = require("../common/Style");
var Note_1 = require("./Note");
var certifierStyle = {
    display: 'block',
    fontWeight: 'bold',
    color: Style_1.primaryFontColor,
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap'
};
var noteStyle = {
    marginTop: 14,
    marginBottom: Style_1.largeSpace,
    fontSize: Style_1.tinyFontSize,
    color: Style_1.secondaryFontColor
};
/**
 * Test id attribute value (prefix) for content of certification tooltip component.
 */
exports.certificationTooltipTestId = 'certification-tooltip';
/**
 * Certification tooltip component.
 * @param props - The props for this certification tooltip.
 */
function CertificationTooltipComponent(props) {
    // NOTE this function could make an AJAX request
    var getContent = function () { return Promise.resolve(React.createElement(Content, __assign({}, props))); };
    return (React.createElement(widgets_1.ChromeTooltipWidget, { getContent: getContent, width: Style_1.tooltipSize, boundaryElement: props.boundaryElement, zIndex: props.zIndex }, props.icon || React.createElement(CertificationIcon_1.CertificationIconComponent, { id: props.id, className: props.className, style: props.style })));
}
exports.CertificationTooltipComponent = CertificationTooltipComponent;
function Content(props) {
    var showExtractRefresh = props.showExtractRefresh === undefined ? true : props.showExtractRefresh;
    return (React.createElement("div", { "data-tb-test-id": (0, Id_1.generateId)(exports.certificationTooltipTestId, props.id), style: Style_1.tooltipStyle },
        showExtractRefresh && React.createElement(ExtractRefresh_1.ExtractRefreshComponent, { date: props.date, customStyle: certifierStyle }),
        React.createElement(Certifier_1.CertifierComponent, __assign({ style: certifierStyle }, props.certifier, { newTab: true, linksDisabled: props.linksDisabled || false })),
        typeof props.note === 'string' ? React.createElement(Note_1.NoteComponent, { style: noteStyle, note: props.note }) : props.note));
}
//# sourceMappingURL=CertificationTooltip.js.map